export function recommendBelt(value, unit = 'in') {
  if (typeof value !== 'number' || !Number.isFinite(value) || value <= 0) return null;
  const waist = Math.round((unit === 'cm' ? value / 2.54 : value) * 1000000) / 1000000;
  if (waist < 20 || waist > 70) return null;
  if (waist < 29) return { waist, size: 95 - 5 * Math.ceil((29 - waist) / 2), estimated: true, cutToFit: true };
  if (waist <= 33) return { waist, size: 95, estimated: false, cutToFit: true };
  if (waist <= 36) return { waist, size: 100, estimated: false, cutToFit: true };
  if (waist <= 40) return { waist, size: 105, estimated: false, cutToFit: true };
  if (waist <= 42) return { waist, size: 110, estimated: false, cutToFit: true };
  return { waist, size: 110 + 5 * Math.ceil((waist - 42) / 2), estimated: true, cutToFit: false };
}

if (typeof customElements !== 'undefined' && !customElements.get('dl-belt-finder')) {
  customElements.define('dl-belt-finder', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.querySelector('form').addEventListener('submit', (event) => {
        event.preventDefault();
        const input = this.querySelector('input');
        const unit = this.querySelector('select').value;
        const output = this.querySelector('[data-result]');
        const raw = input.value.trim();
        const result = raw ? recommendBelt(Number(raw), unit) : null;
        output.hidden = false;
        if (!result) {
          output.textContent = this.dataset.invalid;
          input.setAttribute('aria-invalid', 'true');
          input.focus();
          return;
        }
        input.removeAttribute('aria-invalid');
        this.closest('dl-belt-guide')?.querySelectorAll('[data-size]').forEach(row => row.dataset.recommended = String(Number(row.dataset.size) === result.size));
        output.replaceChildren();
        const title = document.createElement('strong');
        title.textContent = (result.estimated ? this.dataset.estimate : this.dataset.recommend).replace('[size]', String(result.size));
        output.append(title);
        const note = document.createElement('p');
        note.textContent = result.estimated ? this.dataset.outside : this.dataset.fit;
        output.append(note);
        if (result.cutToFit) {
          const cut = document.createElement('p');
          cut.textContent = this.dataset.cut;
          output.append(cut);
        }
      }, { signal: this.controller.signal });
      this.querySelector('select').addEventListener('change', () => {
        this.querySelector('[data-result]').hidden = true;
        this.querySelector('input').removeAttribute('aria-invalid');
      }, { signal: this.controller.signal });
      this.querySelector('input').addEventListener('input', () => {
        this.querySelector('[data-result]').hidden = true;
        this.querySelector('input').removeAttribute('aria-invalid');
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

if (typeof customElements !== 'undefined' && !customElements.get('dl-belt-guide')) {
  customElements.define('dl-belt-guide', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const dialog = this.querySelector('dialog');
      const opener = this.querySelector('[data-open]');
      if (!dialog || !opener) return;
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-open')) dialog.showModal();
        if (button.hasAttribute('data-close')) dialog.close();
        if (button.dataset.panel) {
          this.querySelectorAll('[data-panel]').forEach(tab => tab.setAttribute('aria-pressed', String(tab === button)));
          this.querySelectorAll('[data-content]').forEach(panel => panel.hidden = panel.dataset.content !== button.dataset.panel);
        }
        if (button.dataset.unit) {
          const unit = button.dataset.unit;
          this.querySelectorAll('[data-unit]').forEach(toggle => toggle.setAttribute('aria-pressed', String(toggle === button)));
          this.querySelectorAll('[data-in]').forEach(cell => cell.textContent = cell.dataset[unit]);
          this.querySelector('[data-unit-label]').textContent = unit;
          const select = this.querySelector('select');
          const input = this.querySelector('input');
          if (input.value && select.value !== unit) input.value = String(Math.round(Number(input.value) * (unit === 'cm' ? 2.54 : 1 / 2.54) * 1000000) / 1000000);
          select.value = unit;
        }
      }, { signal: this.controller.signal });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }, { signal: this.controller.signal });
      dialog.addEventListener('close', () => opener.focus(), { signal: this.controller.signal });
    }
    disconnectedCallback() { this.querySelector('dialog')?.close(); this.controller?.abort(); }
  });
}
